import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Box,
  Stack,
  Link,
  Typography,
  FormControl,
  Paper,
  IconButton,
  Snackbar,
  Alert,
  Dialog,
  DialogTitle,
  Backdrop,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { Clear } from "@mui/icons-material";

import store from "../../store";
import {
  Header,
  MainColorButton,
  Loading,
  ImageUploadWebcam,
} from "../../components";
import { bottomButton } from "../../common/styles";
import { FINISHED_PRESCRIPTION } from "../../routes/path";

import { QrReader } from "react-qr-reader";
import { compressAccurately } from "image-conversion";
import { toBase64 } from "../../utils/photoUtil";

import {
  putInsurancePrescriptionPhoto,
  prescriptionRegistration,
  getPrescriptionPhotoSample,
} from "../../server/axios";

const ViewFinder = () => (
  <>
    <svg
      width="50px"
      viewBox="0 0 100 100"
      style={{
        top: 0,
        left: 0,
        zIndex: 1,
        boxSizing: "border-box",
        border: "50px solid rgba(0, 0, 0, 0.3)",
        position: "absolute",
        width: "100%",
        height: "100%",
      }}
    >
      <path
        fill="none"
        d="M13,0 L0,0 L0,13"
        stroke="rgba(255, 0, 0, 0.5)"
        strokeWidth="5"
      />
      <path
        fill="none"
        d="M0,87 L0,100 L13,100"
        stroke="rgba(255, 0, 0, 0.5)"
        strokeWidth="5"
      />
      <path
        fill="none"
        d="M87,100 L100,100 L100,87"
        stroke="rgba(255, 0, 0, 0.5)"
        strokeWidth="5"
      />
      <path
        fill="none"
        d="M100,13 L100,0 87,0"
        stroke="rgba(255, 0, 0, 0.5)"
        strokeWidth="5"
      />
    </svg>
  </>
);

/**
 * 処方箋申込[処方箋]
 * @returns
 */
const PrescriptionCreator = () => {
  const [endY, setEndY] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();

  const pharmacySelectedByState = (state) =>
    state.prescription.pharmacySelected;

  const customerSelectedByState = (state) =>
    state.prescription.customerSelected;

  const selectPrescriptionTypeByState = (state) =>
    state.prescription.prescriptionType;

  // 服薬指導種類setPrescriptionDirector
  const prescriptionDirectorByState = (state) =>
    state.prescription.prescriptionDirector;
  // 服薬指導予約
  const prescriptionReservationByState = (state) =>
    state.prescription.prescriptionReservation;

  const tenantId = useRef();
  const locationId = useRef();
  const customerId = useRef();
  const familyId = useRef();
  const medicationGuidanceKind = useRef(); //服薬指導種類 "1" | "2"
  const isReserve = useRef(); //服薬指導予約時間を指定しているか
  const reserveDateTime = useRef(); //服藥指導預約時間  今はまだ
  const accountingType = useRef(); // 会計種別1:対面, 2:オンライン 、 この流れではわからない
  const prescriptionDrugsReceiptType = useRef(); //処方薬受取種別 1:対面, 2:ロッカー 、 この流れではわからない
  const receptedNumber = useRef();
  const liffId = useRef();
  const lineId = useRef();
  const message = useRef();

  const insurancePhoto1 = useRef();
  const insurancePhoto2 = useRef();
  const insurancePhoto3 = useRef();
  const exemptionCertificatePhotos = useRef();
  const [prescriptionType, setPrescriptionType] = useState({}); // 処方箋の種類 { id: string ,name:string} 1:画像, 2:QR, 3:FAX, 4:電子処方箋
  const updateAt = useRef();

  const [showCamera, setShowCamera] = useState(false);
  // QR関連
  const [showScanner, setShowScanner] = useState(false);
  const scanResult = useRef("");
  const [scanStatus, setScanStatus] = useState("0"); // "0" pending,  "1" success ,"2" :error

  const [isReregistration, setIsReregistration] = useState(false);
  // 処方箋写真配列
  const [prescriptionPhotos, setPrescriptionPhotos] = useState([]);
  // 処方箋写真数
  const prescriptionPhotoCount = useRef(1);

  // Loadingコンポネント表示非表示state
  const [loadingOpen, setLoadingOpen] = useState(false);
  // 登録ボタンの状態
  const [nextBtnDiasble, setNextBtnDisable] = useState(true);
  // 原本のポップアップの表示非表示state
  const [originalPopupOpen, setOriginalPopupOpen] = useState(false);
  const [isOriginalChecked, setIsOriginalChecked] = useState(false);

  //エラーメッセージ表示
  const [openSnackbar, setOpenSnackbar] = useState({
    status: false,
    message: "",
  });
  const handleSnackbarClose = () => {
    setOpenSnackbar({
      status: false,
      message: "",
    });
  };

  //サンプル写真ダイアログ
  const [samplePhotoDialogOpen, setSamplePhotoDialogOpen] = useState(false);
  const [sampleImage, setSampleImage] = useState();
  const [sampleImageTitle, setSampleImageTitle] = useState("撮影例");
  // 処方箋の写真サンプル
  const samplePhotoUrlPaths = useRef([]);

  // サンプル写真ダイアログ開く
  const openSamplePhotoDialog = (index) => {
    try {
      setSampleImageTitle("撮影例");
      setSampleImage(samplePhotoUrlPaths.current[index]);
      setSamplePhotoDialogOpen(true);
    } catch (error) {
      console.error(error);
    }
  };
  //撮影した処方箋の写真ダイアログが開きます
  const openShootPhotoDialog = (index) => {
    const file = prescriptionPhotos[index];
    const url = URL.createObjectURL(file);
    setSampleImage(url);
    setSampleImageTitle("処方箋");
    setSamplePhotoDialogOpen(true);
  };

  //処方箋の写真サンプルの取得
  const prescriptionPhotoSample = async () => {
    try {
      setLoadingOpen(true);
      const { data } = await getPrescriptionPhotoSample();
      samplePhotoUrlPaths.current = [
        data.insurance1,
        data.insurance2,
        data.insurance3,
        data.prescription,
      ];
      setLoadingOpen(false);
    } catch (error) {
      console.error(error);
    }
  };

  //処方箋がFAXの場合は直接登録
  const registrationForElectronicReceipt = async (prescriptionType) => {
    //処方箋再登録
    let data = {
      mode: isReregistration ? "2" : "1", // mode 1:登録, 2:再登録
      liffId: liffId.current,
      tenantId: tenantId.current, // テナントID
      locationId: locationId.current, // 拠点ID,
      customerId: customerId.current, //  利用者ID
      familyId: familyId.current, // 家族ID
      prescriptionClass: prescriptionType.id, //処方箋申込区分  1:画像, 2:QR, 3:FAX, 4:電子処方箋
      medicationGuidanceKinds: medicationGuidanceKind.current, // 服薬指導種別 1:対面, 2:電話
      medicationGuidanceReserveDatetime: reserveDateTime.current, //  服薬指導予約日時
      accountingType: accountingType.current, //  会計種別1:対面, 2:オンライン
      prescriptionDrugsReceiptType: prescriptionDrugsReceiptType.current, // 処方薬受取種別 1:対面, 2:ロッカー
    };

    if (
      insurancePhoto1.current &&
      insurancePhoto2.current &&
      insurancePhoto3.current
    ) {
      data.insurancePhoto1 = insurancePhoto1.current;
      data.insurancePhoto2 = insurancePhoto2.current;
      data.insurancePhoto3 = insurancePhoto3.current;
    }
    if (exemptionCertificatePhotos.current) {
      data.exemptionCertificatePhotos = exemptionCertificatePhotos.current;
    }

    setLoadingOpen(true);
    try {
      const res = await prescriptionRegistration(data);
      if (res.data.result === 1) {
        navigate(FINISHED_PRESCRIPTION, {
          state: {
            message: message.current,
            isReregistration: isReregistration,
          },
          replace: true,
        });
      } else {
        setOpenSnackbar({
          status: true,
          message: `処方箋の連携に失敗しました。再度申し込みをお願いします。`,
        });
      }
    } catch (error) {
      setOpenSnackbar({
        status: true,
        message: `処方箋の連携に失敗しました。再度申し込みをお願いします。`,
      });
    } finally {
      setLoadingOpen(false);
    }
  };

  //  次ページのボタンを押します
  // 登録ボタンの動作
  const handleNextbtn = async () => {
    const uploadedPrescriptionPhotos = prescriptionPhotos.filter(
      (photo) => photo.uploaded && photo.filePath && photo.fileName
    );
    const readyPrescriptionPhotos = uploadedPrescriptionPhotos.map((photo) => {
      return { filePath: photo.filePath, fileName: photo.fileName };
    });

    //処方箋がFAXの場合は直接登録
    if (prescriptionType.id === "3") {
      await registrationForElectronicReceipt(prescriptionType);
      return;
    }

    //処方箋の種類がQRの場合
    if (prescriptionType.id === "2") {
      if (scanResult.current === "") {
        setOpenSnackbar({
          status: true,
          message: "処方箋のQRをスキャンしてください。",
        });
        return;
      }
    } else {
      //処方箋の種類が画像、電子処方箋の場合
      if (readyPrescriptionPhotos.length === 0) {
        setOpenSnackbar({
          status: true,
          message: "処方箋の写真をアップロードしてください。",
        });
        return;
      }
    }

    //処方箋再登録
    let data = {
      mode: isReregistration ? "2" : "1", // mode 1:登録, 2:再登録
      liffId: liffId.current,
      tenantId: tenantId.current, // テナントID
      locationId: locationId.current, // 拠点ID,
      customerId: customerId.current, //  利用者ID
      familyId: familyId.current, // 家族ID
      prescriptionClass: prescriptionType.id, //処方箋申込区分  1:画像, 2:QR, 3:FAX, 4:電子処方箋
      medicationGuidanceKinds: medicationGuidanceKind.current, // 服薬指導種別 1:対面, 2:電話
      medicationGuidanceReserveDatetime: reserveDateTime.current, //  服薬指導予約日時
      accountingType: accountingType.current, //  会計種別1:対面, 2:オンライン
      prescriptionDrugsReceiptType: prescriptionDrugsReceiptType.current, // 処方薬受取種別 1:対面, 2:ロッカー
      updateAt: updateAt.current,
      receptedNumber: receptedNumber.current,
    };

    if (prescriptionType.id === "2") {
      data.qrData = scanResult.current;
    } else {
      data.prescriptionPhotos = readyPrescriptionPhotos;
    }

    if (
      insurancePhoto1.current &&
      insurancePhoto2.current &&
      insurancePhoto3.current
    ) {
      data.insurancePhoto1 = insurancePhoto1.current;
      data.insurancePhoto2 = insurancePhoto2.current;
      data.insurancePhoto3 = insurancePhoto3.current;
    }
    if (exemptionCertificatePhotos.current) {
      data.exemptionCertificatePhotos = exemptionCertificatePhotos.current;
    }

    setLoadingOpen(true);
    try {
      const res = await prescriptionRegistration(data);
      if (res.data.result === 1) {
        if (prescriptionType.id === "1" || prescriptionType.id === "2") {
          setOriginalPopupOpen(true);
        } else if (prescriptionType.id === "3" || prescriptionType.id === "4") {
          navigate(FINISHED_PRESCRIPTION, {
            state: {
              message: message.current,
              isReregistration: isReregistration,
            },
            replace: true,
          });
        }
      } else {
        setOpenSnackbar({
          status: true,
          message: `【処方箋の連携に失敗しました。
          再度申し込みをお願いします。】`,
        });
      }
    } catch (error) {
      setOpenSnackbar({
        status: true,
        message: `【処方箋の連携に失敗しました。
        再度申し込みをお願いします。】`,
      });
    } finally {
      setLoadingOpen(false);
    }
  };

  // 処方箋QR結果の処理
  const handleScanResult = (result, error) => {
    if (!!result) {
      if (result.text.startsWith("JAHIS")) {
        scanResult.current = result.text;
        setScanStatus("1");
        setShowScanner(false);
        setNextBtnDisable(false);
      } else {
        setScanStatus("2");
        setNextBtnDisable(true);
      }
    }
    if (!!error) {
      console.info(error);
      scanResult.current = "";
    }
  };

  // 処方箋写真削除
  const removePhoto = (index) => {
    prescriptionPhotos.splice(index, 1);
    setPrescriptionPhotos(Array.from(prescriptionPhotos));
  };

  // 処方箋写真アップロード
  const uploadPrescriptionPhotos = async (photo) => {
    setLoadingOpen(true);
    try {
      const res = await compressAccurately(photo, {
        size: 1024 * 3,
        type: "JPEG",
      });
      const photoBase64 = await toBase64(res);
      const data = {
        lineId: lineId.current,
        type: 3, //1:保険証 2:減免証書 3:処方箋
        photoNumber: photo.id,
        fileData: photoBase64,
      };
      const uploadRes = await putInsurancePrescriptionPhoto(data);
      if (uploadRes.data.filePath && uploadRes.data.fileName) {
        prescriptionPhotoCount.current = prescriptionPhotoCount.current + 1;
        const { filePath, fileName } = uploadRes.data;
        photo.uploaded = true;
        photo.filePath = filePath;
        photo.fileName = fileName;
        prescriptionPhotos.push(photo);
        setPrescriptionPhotos(Array.from(prescriptionPhotos));
      }
    } catch (error) {
      setOpenSnackbar({
        status: true,
        message: "写真のアップロードに失敗しました。",
      });
    } finally {
      setLoadingOpen(false);
    }
  };

  // アップロードボタンの表示
  useEffect(() => {
    if (prescriptionType.id !== "2") {
      if (prescriptionPhotos.length === 0) {
        setNextBtnDisable(true);
        return;
      }
      setNextBtnDisable(!!prescriptionPhotos.find((photo) => !photo.uploaded));
    }
  }, [prescriptionPhotos]);

  // 各種パラメータ初期化
  useEffect(() => {
    const selectLineInfo = (state) => state.prescription.lineInfo;
    const lineInfo = selectLineInfo(store.getState());
    liffId.current = lineInfo.liffId;
    lineId.current = lineInfo.lineId;

    // 最初にstate読み取りから再登録するかどうか
    setIsReregistration(location.state?.isReregistration ?? false);

    //メッセージをジャンプするかどうか
    message.current = location.state?.message ?? false;

    // 保険証減免証明書等の写真情報
    insurancePhoto1.current = location.state?.insurancePhoto1;
    insurancePhoto2.current = location.state?.insurancePhoto2;
    insurancePhoto3.current = location.state?.insurancePhoto3;
    exemptionCertificatePhotos.current =
      location.state?.exemptionCertificatePhotos;
    if (location.state?.isReregistration) {
      //再登録
      tenantId.current = location.state?.tenantId;
      customerId.current = location.state?.customerId;
      familyId.current = location.state?.familyId;
      receptedNumber.current = location.state?.receptedNumber;
      //再登録の場合にstate処方箋の種類読み
      setPrescriptionType(location.state?.prescriptionType);
      updateAt.current = location.state?.updateAt;
    } else {
      // 登録
      // 登録の場合にstate処方箋の種類読み
      const prescriptionType = selectPrescriptionTypeByState(store.getState());
      setPrescriptionType(prescriptionType);
      let pharmacySelected = pharmacySelectedByState(store.getState());
      // 処方箋受付テナントID
      tenantId.current = pharmacySelected.selectedRows.tenantId;
      // 処方箋受付 拠点ID
      locationId.current = pharmacySelected.selectedRows.locationId;
      let customerSelected = customerSelectedByState(store.getState());
      // 処方箋受付 利用者ID
      customerId.current = customerSelected.selectedRows.customerId;
      // 処方箋受付 家族ID
      familyId.current = customerSelected.selectedRows.familyId;
      // 処方箋受付 服薬指導種別
      let prescriptionDirector = prescriptionDirectorByState(store.getState());
      // 処方箋受付 服薬指導種別
      medicationGuidanceKind.current = prescriptionDirector.id;
      // 処方箋受付 服薬指導 予約
      let medicationGuidanceReserveDatetime = prescriptionReservationByState(
        store.getState()
      );

      //服薬指導 時間予約するかどうか
      isReserve.current = medicationGuidanceReserveDatetime?.id;

      // 処方箋受付 服薬指導時間
      reserveDateTime.current = location.state?.reservationDate;

      //処方箋の種類 1:画像, 2:QR, 3:FAX, 4:電子処方箋
      //服薬指導 1:対面, 2:電話
      if (prescriptionType.id === "3" || prescriptionType.id === "4") {
        // 処方薬受取種別 2:ロッカー
        prescriptionDrugsReceiptType.current = "2";
        // 会計種別2:オンライン
        accountingType.current = "2";
      }

      if (prescriptionType.id === "1" || prescriptionType.id === "2") {
        // 処方薬受取種別 1:対面
        prescriptionDrugsReceiptType.current = "1";
        //会計種別 1:対面
        accountingType.current = "1";
      }

      //処方箋がFAXの場合は直接登録
      if (prescriptionType.id === "3") {
        registrationForElectronicReceipt(prescriptionType);
      }
    }
    prescriptionPhotoSample();
  }, []);

  return (
    <>
      <div
        onTouchStartCapture={(e) => {
          setEndY(0);
        }}
        onTouchMoveCapture={(e) => {
          setEndY(e.touches[0].clientY);
        }}
        onTouchEndCapture={(e) => {
          if (endY !== 0) {
            e.stopPropagation();
          }
        }}
      >
        <Loading open={loadingOpen} />
        <Header
          title={isReregistration ? "処方箋再登録" : "処方箋申込[処方箋]"}
        />
        <Backdrop
          sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={originalPopupOpen}
        >
          <Box
            sx={{
              height: "50vh",
              width: "80%",
              backgroundColor: "#fff",
              padding: "40px",
              boxSizing: "border-box",
            }}
          >
            <p>
              お手元の処方箋原本は薬局に提出が必要です。
              <br />
              大切に保管し、来局の際にお持ちください。
            </p>
            <FormControlLabel
              control={
                <Checkbox
                  checked={isOriginalChecked}
                  value={isOriginalChecked}
                  onChange={() => {
                    setIsOriginalChecked(!isOriginalChecked);
                  }}
                />
              }
              label="確認しました"
            />
            <MainColorButton
              label={"次へ"}
              onClick={() => {
                navigate(FINISHED_PRESCRIPTION, {
                  state: {
                    message: message.current,
                    isReregistration: isReregistration,
                  },
                  replace: true,
                });
              }}
              style={{
                marginTop: "4vh",
                width: "100%",
                height: "6vh",
                fontSize: "120%",
              }}
              disabled={!isOriginalChecked}
            />
          </Box>
        </Backdrop>
        <Snackbar
          open={openSnackbar.status}
          autoHideDuration={5000}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          onClose={handleSnackbarClose}
          sx={{ mt: "8vh" }}
        >
          <Alert
            severity="error"
            sx={{ width: "100%" }}
            onClose={handleSnackbarClose}
          >
            {openSnackbar.message}
          </Alert>
        </Snackbar>
        <Box
          height="10vh"
          marginTop="9vh"
          width="95%"
          marginLeft="auto"
          marginRight="auto"
        >
          <Dialog
            fullWidth={true}
            maxWidth={"md"}
            onClose={() => setSamplePhotoDialogOpen(false)}
            open={samplePhotoDialogOpen}
          >
            <DialogTitle>{sampleImageTitle}</DialogTitle>
            <img
              alt="sampleImage"
              style={{ width: "100%", maxHeight: "60vh", objectFit: "cover" }}
              src={sampleImage}
              loading="lazy"
            />
          </Dialog>

          <Stack
            direction="row"
            justifyContent="space-around"
            alignItems="center"
          >
            <Typography variant="subtitle1" align="left">
              処方箋種類
            </Typography>
            <Box width="40%" textAlign="center">
              <FormControl fullWidth>
                <Paper elevation={0} variant="outlined" sx={{ border: 1 }}>
                  <Typography padding="2%" variant="body2">
                    {prescriptionType?.name}
                  </Typography>
                </Paper>
              </FormControl>
            </Box>
          </Stack>
          {(prescriptionType?.id === "1" || prescriptionType?.id === "4") && (
            <Typography variant="subtitle1" align="left" marginTop="3%">
              処方箋を全ページ撮影してください。
            </Typography>
          )}
          {prescriptionType?.id === "2" && (
            <Typography variant="subtitle1" align="left" marginTop="3%">
              処方箋のQRコードを読み取りしてください。
            </Typography>
          )}
        </Box>
        <Stack
          direction="row"
          justifyContent="flex-end"
          alignItems="flex-end"
          height="3vh"
          backgroundColor="#bdbdbd"
          paddingX={1}
        >
          {(prescriptionType?.id === "1" || prescriptionType?.id === "4") && (
            <Typography>
              <Link onClick={() => openSamplePhotoDialog(3)}>撮影例</Link>
            </Typography>
          )}
        </Stack>
        <Box height="65vh" width="95%" marginLeft="auto" marginRight="auto">
          <Stack>
            <Box
              width="100%"
              marginLeft="auto"
              marginRight="auto"
              marginTop="6%"
            >
              <Stack spacing={2}>
                {(prescriptionType?.id === "1" ||
                  prescriptionType?.id === "4") && (
                  <>
                    {showCamera && (
                      <ImageUploadWebcam
                        onCapture={(imageFile) => {
                          if (imageFile) {
                            imageFile.uploaded = false;
                            imageFile.id = prescriptionPhotoCount.current;
                            uploadPrescriptionPhotos(imageFile);
                          }
                          setShowCamera(false);
                        }}
                      />
                    )}
                    <Stack
                      direction="column"
                      justifyContent="center"
                      alignItems="center"
                      sx={{
                        height: "5vh",
                        marginLeft: "25%",
                        width: "50%",
                        boxShadow: 5,
                        backgroundColor: "#c5e1a5",
                      }}
                      onClick={() => setShowCamera(true)}
                    >
                      <Typography textAlign="center">カメラを起動</Typography>
                    </Stack>

                    <Stack spacing={1} maxHeight="45vh" overflow="scroll">
                      {prescriptionPhotos.length === 0 && (
                        <Stack
                          direction="row"
                          justifyContent="center"
                          alignItems="center"
                          spacing={1}
                        >
                          <Box width="90%">
                            <FormControl fullWidth>
                              <Paper
                                elevation={0}
                                variant="outlined"
                                sx={{ border: 1 }}
                              >
                                <Typography
                                  color={"#e0e0e0"}
                                  padding="2%"
                                  variant="body2"
                                >
                                  画像ファイルが選択されていません。
                                </Typography>
                              </Paper>
                            </FormControl>
                          </Box>
                        </Stack>
                      )}

                      {prescriptionPhotos.map((photo, index) => (
                        <Stack
                          key={index}
                          direction="row"
                          justifyContent="center"
                          alignItems="center"
                          spacing={1}
                        >
                          <Box width="90%">
                            <FormControl fullWidth>
                              <Paper
                                key={`exemptionCertificatePhotos-${index}`}
                                elevation={0}
                                variant="outlined"
                                sx={{
                                  border: 1,
                                  flexDirection: "row",
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                                onClick={() => {
                                  openShootPhotoDialog(index);
                                }}
                              >
                                <Typography
                                  padding="2%"
                                  variant="body2"
                                  sx={{
                                    overflowWrap: "break-word",
                                    width: "70%",
                                  }}
                                >
                                  {photo.name}
                                </Typography>

                                <IconButton
                                  sx={{
                                    display: "inline-block",
                                    padding: "2%",
                                  }}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    removePhoto(index);
                                  }}
                                >
                                  <Box sx={{ position: "relative" }}>
                                    <Stack
                                      direction="row"
                                      alignItems="center"
                                      justifyContent="center"
                                      sx={{
                                        height: "100%",
                                        lineHeight: "100%",
                                      }}
                                    >
                                      <Clear />
                                    </Stack>
                                  </Box>
                                </IconButton>
                              </Paper>
                            </FormControl>
                          </Box>
                        </Stack>
                      ))}
                      {prescriptionPhotos.length === 0 && (
                        <Typography color="red" textAlign="center">
                          画像がアップロードされていません。
                        </Typography>
                      )}
                    </Stack>
                  </>
                )}
                {prescriptionType?.id === "2" && (
                  <>
                    {showScanner ? (
                      <div
                        style={{
                          width: "300px",
                          marginLeft: "auto",
                          marginRight: "auto",
                        }}
                      >
                        <QrReader
                          ViewFinder={ViewFinder}
                          videoId={"video"}
                          constraints={{
                            facingMode: "environment",
                          }}
                          onResult={handleScanResult}
                        />
                        <MainColorButton
                          label="カメラを閉じる"
                          onClick={() => setShowScanner(false)}
                          style={{
                            height: "5vh",
                            variant: "subtitle1",
                            marginLeft: "25%",
                            width: "50%",
                            marginTop: "2vh",
                          }}
                        />
                      </div>
                    ) : (
                      <>
                        <MainColorButton
                          label="カメラを起動"
                          onClick={() => setShowScanner(true)}
                          style={{
                            height: "5vh",
                            variant: "subtitle1",
                            marginLeft: "25%",
                            width: "50%",
                          }}
                        />

                        <Typography color="red" textAlign="center">
                          {scanStatus === "0" &&
                            "処方箋QRコードを撮影してください"}
                          {scanStatus === "1" &&
                            "処方箋QRコードが読み込まれました。"}
                          {scanStatus === "2" &&
                            "QRコードを読み込んでいません。"}
                        </Typography>
                      </>
                    )}
                  </>
                )}
              </Stack>
            </Box>
          </Stack>
        </Box>
        <MainColorButton
          label={"登録"}
          onClick={() => handleNextbtn()}
          style={bottomButton}
          disabled={nextBtnDiasble}
        />
      </div>
    </>
  );
};

export default PrescriptionCreator;
